import { css } from "glamor";
import React, { useMemo } from "react";
import { colors, spacing, styles, typographyColors } from "../library/theme";
import ScaleupPlayer from "../library/ScaleupPlayer";
import VimeoPlayer from "../library/VimeoPlayer";
import { FaRegComments } from "react-icons/fa6";

const sectionTitle = css({
  marginTop: spacing.l,
  marginBottom: spacing.m,
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
  gap: spacing.xs,
  ...styles.bodyTextLarge,
  color: typographyColors.blackLetters,
});

const iconStyle = {
  color: colors.primaryDarker,
};

const sectionContainer = css({
  marginTop: spacing.l,
  marginBottom: spacing.m,
});

const audioContainer = css({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: colors.greyClear,
  borderRadius: spacing.xs,
  padding: spacing.m,
});

const audioElement = css({
  width: "100%",
  maxWidth: "800px",
});

const textContainer = css({
  width: "100%",
  minHeight: "200px",
  padding: spacing.m,
  backgroundColor: colors.greyClear,
  borderRadius: spacing.xs,
  overflow: "auto",
});

const textContent = css({
  ...styles.wrappingText,
  whiteSpace: "pre-line",
  color: typographyColors.blackLetters,
  fontWeight: "500",
  "& p": {
    marginBottom: spacing.s,
    color: typographyColors.blackLetters,
    fontWeight: "500",
  },
  "& *": {
    color: typographyColors.blackLetters,
  },
});

export default function QuestionComments({ question }) {
  if (!question) {
    return null;
  }

  const availableComments = useMemo(() => {
    const comments = {
      video: false,
      text: false,
      audio: false,
    };

    if (question?.scaleupUrl || question?.vimeoUrl || question?.commentVideoUrl) {
      comments.video = true;
    }

    if (question?.commentText) {
      comments.text = true;
    }

    if (question?.commentFileUrl) {
      comments.audio = true;
    }

    return comments;
  }, [question]);

  const hasAnyComments = availableComments.video || availableComments.text || availableComments.audio;

  if (!hasAnyComments) {
    return null;
  }

  let videoUrl = null;
  let useScaleup = false;

  if (availableComments.video) {
    if (question?.scaleupUrl) {
      videoUrl = question.scaleupUrl;
      useScaleup = true;
    } else if (question?.vimeoUrl) {
      videoUrl = question.vimeoUrl;
      useScaleup = false;
    } else if (question?.commentVideoUrl) {
      videoUrl = question.commentVideoUrl;
      useScaleup = false;
    }
  }

  return (
    <div>
      <h3 className={sectionTitle} style={{ marginTop: 0 }}>
        <FaRegComments size={22} style={iconStyle} /> Comentário da Questão
      </h3>

      {availableComments.video && (
        <div className={sectionContainer}>
          {useScaleup ? (
            <ScaleupPlayer url={videoUrl} />
          ) : (
            <VimeoPlayer url={videoUrl} />
          )}
        </div>
      )}

      {availableComments.audio && (
        <div className={sectionContainer}>
          <div className={audioContainer}>
            <audio
              className={audioElement}
              controls
              src={question.commentFileUrl}
            >
              Seu navegador não suporta o elemento de áudio.
            </audio>
          </div>
        </div>
      )}

      {availableComments.text && (
        <div className={sectionContainer}>
          <div className={textContainer}>
            <div
              className={textContent}
              dangerouslySetInnerHTML={{ __html: question.commentText }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
